import React from 'react';
import { CheckCircle, Award, Tv, Radio } from 'lucide-react';

const About = () => {
  return (
    <section id="sobre-mi" className="bg-[#f6f5e8] py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <span className="text-sm text-[#1a365d] tracking-wider uppercase">Sobre mí</span>
          <h2 className="text-3xl lg:text-4xl font-light text-[#333333] mt-4 leading-tight">
            Compromiso con la excelencia inmobiliaria
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          <div className="space-y-6">
            <p className="text-lg text-[#333333] leading-relaxed">
              Soy Javier Blanco Rojo, fundador y director de JBR INMOBILIARIA desde 2004. Con más de dos décadas de experiencia y más de 5.000 transacciones realizadas, mi trayectoria profesional está marcada por un firme compromiso con la excelencia y la satisfacción del cliente.
            </p>
            <p className="text-base text-[#666666] leading-relaxed">
              Licenciado en Administración y Dirección de Empresas por la Universidad de Valladolid, he complementado mi formación con las certificaciones CRS (Certified Residential Specialist) más prestigiosas del sector inmobiliario internacional en Las Vegas, Orlando, Los Ángeles, Phoenix y Miami. Creo firmemente que cada propiedad tiene una historia única y cada propietario merece un asesoramiento personalizado basado en la transparencia y el conocimiento profundo del mercado.
            </p>

            {/* Education */}
            <div className="pt-6">
              <h3 className="text-sm text-[#1a365d] tracking-wider uppercase mb-4">Formación Académica</h3>
              <div className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-[#1a365d] flex-shrink-0 mt-0.5" />
                <span className="text-sm text-[#666666]">Ldo. Administración y Dirección de Empresas - Universidad de Valladolid (1998-2004)</span>
              </div>
            </div>

            {/* Certifications */}
            <div className="pt-4">
              <h3 className="text-sm text-[#1a365d] tracking-wider uppercase mb-4">Certificaciones y Formación Especializada</h3>
              <ul className="space-y-2">
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#1a365d] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-[#666666]">CRS Certified Residential Specialist (Las Vegas, Orlando, Los Ángeles, Phoenix, Miami)</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#1a365d] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-[#666666]">CRS Ninja Selling</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#1a365d] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-[#666666]">CRS Planificación de Negocio</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#1a365d] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-[#666666]">CRS Técnicas de Negociación</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#1a365d] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-[#666666]">CRS Trabajo con el Comprador</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#1a365d] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-[#666666]">Experto en IA Inmobiliaria</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#1a365d] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-[#666666]">Curso Inversión Inmobiliaria</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#1a365d] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-[#666666]">FPI - Finanzas para Inmobiliarios</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#1a365d] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-[#666666]">First Certificate in English</span>
                </li>
              </ul>
            </div>
          </div>

          <div>
            {/* Values Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              <div className="bg-[#fffef2] p-8 hover:shadow-md transition-shadow duration-300">
                <div className="w-10 h-10 flex items-center justify-center bg-[#1a365d]/10 mb-4">
                  <span className="text-lg font-light text-[#1a365d]">01</span>
                </div>
                <h3 className="text-lg font-medium text-[#333333] mb-2">Transparencia</h3>
                <p className="text-sm text-[#666666] leading-relaxed">Comunicación clara y honesta en cada paso del proceso</p>
              </div>
              <div className="bg-[#fffef2] p-8 hover:shadow-md transition-shadow duration-300">
                <div className="w-10 h-10 flex items-center justify-center bg-[#1a365d]/10 mb-4">
                  <span className="text-lg font-light text-[#1a365d]">02</span>
                </div>
                <h3 className="text-lg font-medium text-[#333333] mb-2">Compromiso</h3>
                <p className="text-sm text-[#666666] leading-relaxed">Dedicación total hasta alcanzar los objetivos de cada cliente</p>
              </div>
              <div className="bg-[#fffef2] p-8 hover:shadow-md transition-shadow duration-300">
                <div className="w-10 h-10 flex items-center justify-center bg-[#1a365d]/10 mb-4">
                  <span className="text-lg font-light text-[#1a365d]">03</span>
                </div>
                <h3 className="text-lg font-medium text-[#333333] mb-2">Excelencia</h3>
                <p className="text-sm text-[#666666] leading-relaxed">Mejor Inmobiliaria de CyL en Google 2022, 2023, 2024 y 2025</p>
              </div>
              <div className="bg-[#fffef2] p-8 hover:shadow-md transition-shadow duration-300">
                <div className="w-10 h-10 flex items-center justify-center bg-[#1a365d]/10 mb-4">
                  <span className="text-lg font-light text-[#1a365d]">04</span>
                </div>
                <h3 className="text-lg font-medium text-[#333333] mb-2">Experiencia</h3>
                <p className="text-sm text-[#666666] leading-relaxed">+5.000 transacciones y 21 años liderando el sector</p>
              </div>
            </div>

            {/* Awards */}
            <div className="bg-[#1a365d] p-8 mb-6">
              <div className="flex items-center gap-3 mb-4">
                <Award className="w-6 h-6 text-white" />
                <h3 className="text-sm text-white tracking-wider uppercase">Reconocimientos</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <span className="text-white/60">★</span>
                  <span className="text-sm text-white/90">Mejor Inmobiliaria de Castilla y León - Ranking Google 2022</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-white/60">★</span>
                  <span className="text-sm text-white/90">Mejor Inmobiliaria de Castilla y León - Ranking Google 2023</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-white/60">★</span>
                  <span className="text-sm text-white/90">Mejor Inmobiliaria de Castilla y León - Ranking Google 2024</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-white/60">★</span>
                  <span className="text-sm text-white/90">Mejor Inmobiliaria de Castilla y León - Ranking Google 2025</span>
                </li>
              </ul>
            </div>

            {/* Media Appearances */}
            <div className="bg-[#333333] p-8">
              <div className="flex items-center gap-3 mb-4">
                <Tv className="w-6 h-6 text-white" />
                <h3 className="text-sm text-white tracking-wider uppercase">Apariciones en Medios</h3>
              </div>
              
              <div className="mb-4">
                <p className="text-xs text-white/50 uppercase tracking-wider mb-2">Televisión</p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-white/10 text-sm text-white/90 rounded">Informativos Antena 3</span>
                  <span className="px-3 py-1 bg-white/10 text-sm text-white/90 rounded">TVE</span>
                  <span className="px-3 py-1 bg-white/10 text-sm text-white/90 rounded">Canal 24 Horas</span>
                  <span className="px-3 py-1 bg-white/10 text-sm text-white/90 rounded">Sección semanal La8 Valladolid</span>
                </div>
              </div>
              
              <div>
                <p className="text-xs text-white/50 uppercase tracking-wider mb-2 flex items-center gap-2">
                  <Radio className="w-4 h-4" /> Radio
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-white/10 text-sm text-white/90 rounded">COPE</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
